/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInvestmentEntityHistoricalDataRequest} from '@cash-web/protos/squareup/cash/marketprices/service.pb'
import {GetInvestmentEntityHistoricalDataResponse} from '@cash-web/protos/squareup/cash/marketprices/service.pb'


export const getInvestmentEntityHistoricalData = (request:GetInvestmentEntityHistoricalDataRequest, options?: CashRequestOptions) => post<GetInvestmentEntityHistoricalDataRequest, GetInvestmentEntityHistoricalDataResponse>("/2.0/cash/investing/get-investment-entity-historical-data", request, {...options, rejectOnError: true })